<script setup>
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

defineProps({
  activities: {
    type: Array,
    required: true,
  },
  currentUserName: {
    type: String,
    default: '',
  },
});

const formatDate = date => {
  return format(new Date(date), 'dd MMM yyyy HH:mm', { locale: ptBR });
};
</script>

<template>
  <div class="p-5 rounded-lg border border-n-weak bg-n-solid-2">
    <div class="flex items-center justify-between mb-5">
      <h3 class="text-sm font-medium text-n-slate-12">
        {{ $t('PIPELINE.DASHBOARD.RECENT_ACTIVITY') }}
      </h3>
    </div>
    <div class="space-y-2">
      <div
        v-for="activity in activities"
        :key="activity.id"
        class="flex items-center justify-between p-3 rounded-lg bg-n-alpha-2 hover:bg-n-alpha-3 transition-colors cursor-pointer"
      >
        <div class="flex items-center gap-3 min-w-0">
          <div
            class="w-8 h-8 rounded-lg bg-n-solid-3 flex items-center justify-center flex-shrink-0"
          >
            <Icon icon="i-lucide-file-text" class="size-4 text-n-slate-11" />
          </div>
          <div class="min-w-0">
            <p class="text-sm font-medium text-n-slate-12 truncate">
              {{ activity.title }}
            </p>
            <p class="text-xs text-n-slate-11 mt-0.5 flex items-center gap-1.5">
              <span>{{ activity.stage }}</span>
              <span class="w-1 h-1 rounded-full bg-n-slate-8" />
              <span>{{
                $t('PIPELINE.DASHBOARD.UPDATED_BY', { name: currentUserName })
              }}</span>
            </p>
          </div>
        </div>
        <span class="text-[10px] text-n-slate-11 whitespace-nowrap ml-4">
          {{ formatDate(activity.updatedAt) }}
        </span>
      </div>
      <div
        v-if="activities.length === 0"
        class="flex flex-col items-center justify-center py-12"
      >
        <Icon icon="i-lucide-list" class="size-10 text-n-slate-9 mb-2" />
        <p class="text-sm text-n-slate-11">
          {{ $t('PIPELINE.DASHBOARD.NO_ACTIVITY') }}
        </p>
      </div>
    </div>
  </div>
</template>
